module.exports = __webpack_public_path__ + "static/media/0009.059ed836.png";